import { TP_AirHandlingUnit } from './types'
import { OverviewPanelWrapper } from '../../../components/OverviewPanelWrapper'
import { SmallPanel as DuctPanel } from '../../../SubPlants/SP_AirDuct'
import { SmallPanelTrendOnly as DuctPanelTrendOnly } from '../../../SubPlants/SP_AirDuct'
import { SmallPanel as FanPanel } from '../../../SubPlants/SP_Fan'
import { SmallPanel as HeatingCoilPanel } from '../../../SubPlants/SP_HeatingCoil'
import { SmallPanel as CoolingCoilPanel } from '../../../SubPlants/SP_CoolingCoil'
import { LoadingView } from "../../../../components";
import { themedUseStyletron } from "../../../../theme/customTheme";
import { useGetObjectsChildren } from '../../../../hooks/useGetObjectsChildren';
import React, { Suspense, useMemo } from 'react'
import { IconAHU } from './IconAHU'
import OperationState from './OperationState'
import { HorizontalStackPanel } from '../../../../components/Layout/StackPanel'



export function OverviewPanel(props: TP_AirHandlingUnit) {
    const [css, theme] = themedUseStyletron()
    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const supplyAirDuct = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.SubPlants.AirDucts.SP_SupplyAirDuct"), [childElement]);
    const exhaustAirDuct = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.SubPlants.AirDucts.SP_ExhaustAirDuct"), [childElement]);
    const supplyFans = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.SubPlants.Fans.SP_SupplyFan"), [childElement]);
    const exhaustFans = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.SubPlants.Fans.SP_ExhaustFan"), [childElement]);
    const coolingCoil = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.SubPlants.CoolingCoils.SP_CoolingCoil"), [childElement]);
    const heatingCoil = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.SubPlants.HeatingCoils.SP_HeatingCoil"), [childElement]);


    return (
        <OverviewPanelWrapper height={theme.appSizes.mediumAppHeight} {...props} icon={<IconAHU color={theme.colors.backgroundPrimary}></IconAHU>}>
            <OperationState {...props}></OperationState>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                {props.showHeating && heatingCoil && <HeatingCoilPanel {...heatingCoil}></HeatingCoilPanel>}
                {props.showCooling && coolingCoil && <CoolingCoilPanel {...coolingCoil}></CoolingCoilPanel>}
                {props.showSupplyDuct &&
                    <HorizontalStackPanel  $width={'100%'} $alignItems={'flex-start'}>
                        {supplyFans && <FanPanel  {...supplyFans}></FanPanel>}
                        {supplyAirDuct && <div className={css({zIndex: 10})}><DuctPanel {...supplyAirDuct}></DuctPanel></div>}
                        {props.showTrendPanels && supplyAirDuct && <DuctPanelTrendOnly {...supplyAirDuct}></DuctPanelTrendOnly>}
                    </HorizontalStackPanel>
                }
                {props.showExhaustDuct &&
                    <HorizontalStackPanel  $width={'100%'} $alignItems={'flex-start'}>
                        {exhaustAirDuct && <div className={css({zIndex: 10})}><DuctPanel {...exhaustAirDuct}></DuctPanel></div>}
                        {exhaustFans && <FanPanel  {...exhaustFans}></FanPanel>}
                        {props.showTrendPanels && exhaustAirDuct && <DuctPanelTrendOnly {...exhaustAirDuct}></DuctPanelTrendOnly>}
                    </HorizontalStackPanel>
                }

            </LoadingView>
        </OverviewPanelWrapper>
    );
} 